import { useState, useEffect, useRef, useMemo, forwardRef } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useAuthentication, useTheme } from '../../Hooks';
import "./SwitchCompanyButton.style.css"
import { SvgComponent } from '../SvgComponent/SvgComponent';
import ToolTip from '../ToolTip/Tooltip';
import IconButton from '../IconButton/IconButton';
import { Simplebar } from '../Simplebar/Simplebar';
import { GridView } from '../GridView/GridView';
import Select from 'react-select'
import {CAMBIO_COMPANIA} from "../../Utils";

const Dp = Dropdown;
export function SwitchCompanyButton() {
  const [showCanvas, setShowCanvas] = useState(false);
  const simplebarRef = useRef();
  const [list, setList] = useState([]);
  const [where, setWhere] = useState({});
  const consultaActualId = useRef();
  const {usuario} = useAuthentication();
  const {theme} = useTheme();
  const DEFAULT_PAGINATION_VALUES = {
    EsPaginable: true,
    CantidadPorPagina: 15,
    EsOrdernable: true,
    OrderBy: "IdSec",
    EsAscendente: false,
  };

  const [pagination, setPagination] = useState({
    ...DEFAULT_PAGINATION_VALUES,
    OrderBy: "Id",
  });
  const ESTATUS_LIST = [
    { value: "", label: "Todos" },
    { value: "Activa", label: "ACTIVA" },
    { value: "Bloqueada", label: "BLOQUEADA" },
    { value: "Inactiva", label: "INACTIVA" },
  ];

  useEffect(() => {
    if (showCanvas) {
      buscar();
    }
    return () => {
      hideLoading();
    };
  }, [where, showCanvas]);

  const buscar = () => {
    setPagination({
      ...pagination,
      IsLoading: true,
    });
    let filteredList = usuario?.CompaniasPermitidas; // Define list here
    if (where.Estatus !== undefined) {
      filteredList =
        where.Estatus === ""
          ? filteredList
          : filteredList.filter((e) => e.Estatus === where.Estatus);
    }
    if (where.Codigo !== undefined) {
      filteredList = filteredList.filter((e) =>
        e.Codigo.toLowerCase().includes(where.Codigo)
      );
    }
    if (where.Nombre !== undefined) {
      filteredList = filteredList.filter((e) =>
        e.Nombre.toLowerCase().includes(where.Nombre)
      );
    }
    if (where.Id !== undefined) {
      filteredList = filteredList.filter((e) =>
        e.Id.toString().includes(where.Id)
      );
    }
    setList(filteredList);
    setPagination({
      ...pagination,
      IsLoading: false,
    });
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const showLoading = () => {
    try {
      simplebarRef?.current?.showLoading(true);
    } catch (error) {
      console.dev(error);
    }
  };

  const hideLoading = () => {
    try {
      simplebarRef?.current?.showLoading(false);
    } catch (error) {
      console.dev(error);
    }
  };


  const buscar1 = (url, cuerpo) => {
    return new Promise(function (resolve, reject) {
      // eslint-disable-next-line no-undef
      Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
        // eslint-disable-next-line no-undef
        var datos = $.parseJSON(respuesta.d);
        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  };

  function cambioCompania(id){
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;

      const url =
          CAMBIO_COMPANIA
        buscar1(url, {where: {CompaniaId: id}}).then((data) => {
        if (consultaId === consultaActualId.current) {
          setTimeout(() => {
            window.location.reload();
          }, 2000)
        }
      });
    };
    obtenerDatos();
  }

  const handleClick = (id) => {
    if (id) {
      showLoading();
      cambioCompania(id);
    }
  };

  return (
    <>
      <Dp as={Nav.Item}>
        <Dp.Toggle
          as={Nav.Link}
          id="Dp-company-switch"
          className="buttonHover"
          onClick={() => {
            setShowCanvas(true);
          }}
        >
          <ToolTip placement="left" message="Cambiar Compañía">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              fill="#77777A"
              height="33"
              viewBox="0 -960 960 960"
            >
              <path d="m379.539-248.155 33-32.615-89.001-88.615H520v-45.384H323.538l89.001-88.616-33-32.614-143.922 143.922 143.922 143.922Zm200.922-170.154 143.922-143.922-143.307-143.922-33.23 32.615 88.616 88.616H440v45.383h196.462l-88.616 88.616 32.615 32.614ZM480.067-100.001q-78.221 0-147.397-29.92-69.176-29.92-120.989-81.71-51.814-51.791-81.747-120.936-29.933-69.146-29.933-147.366 0-78.836 29.92-148.204 29.92-69.369 81.71-120.682 51.791-51.314 120.936-81.247 69.146-29.933 147.366-29.933 78.836 0 148.204 29.92 69.369 29.92 120.682 81.21 51.314 51.291 81.247 120.629 29.933 69.337 29.933 148.173 0 78.221-29.92 147.397-29.92 69.176-81.21 120.989-51.291 51.814-120.629 81.747-69.337 29.933-148.173 29.933ZM480-145.385q139.692 0 237.154-97.769Q814.615-340.923 814.615-480q0-139.692-97.461-237.154Q619.692-814.615 480-814.615q-139.077 0-236.846 97.461Q145.385-619.692 145.385-480q0 139.077 97.769 236.846T480-145.385ZM480-480Z" />
            </svg>
          </ToolTip>
        </Dp.Toggle>
      </Dp>

      {createPortal(
        <Simplebar
          ref={simplebarRef}
          size="lg"
          useLoading={true}
          backdrop={true}
          placement={"end"}
          portal={false}
          visible={showCanvas}
          setShow={(e) => {
            setShowCanvas(e);
          }}
          title={"Cambiar Compañía"}
          btnLeft={{
            show: false,
            func: () => {},
          }}
          btnRight={{
            show: false,
            func: () => {},
          }}
        >
          <>
            <GridView
              pagination={pagination}
              setPagination={setPagination}
              allowPaging={pagination.EsPaginable}
              pageSize={pagination.CantidadPorPagina}
              pageIndex={pagination.IndiceDePagina}
              lastPageNumber={pagination.PaginasTotal}
              dataSource={list}
              onPageIndexChanging={onPageIndexChanging}
              where={where}
              setWhere={setWhere}
              height="70vh"
            >
              <GridView.Column
                isSticky
                bodyRenderer={(row) => {
                  return (
                    <>
                      <div className="float-right">
                        <IconButton onClick={() => handleClick(row.Id)}>
                          <ToolTip message="Ingresar">
                            <div>
                              <SvgComponent
                                iconName="user"
                                height="25"
                                width="25"
                                fill={theme.color1}
                              />
                            </div>
                          </ToolTip>
                        </IconButton>
                      </div>
                    </>
                  );
                }}
              />

              {list &&
                list.length > 0 &&
                list.some((l) => l.Id !== null && l.Id !== undefined) && (
                  <GridView.Column
                    headerText="Id"
                    dataField="Id"
                    sortExpression="Id"
                    width="100px"
                  />
                )}

              <GridView.Column
                headerText="Nombre"
                dataField="Nombre"
                sortExpression="Nombre"
              />
              <GridView.Column
                headerText="Código"
                dataField="Codigo"
                sortExpression="Codigo"
              />
              <GridView.Column
                headerText="Estatus"
                dataField="Estatus"
                sortExpression="Estatus"
                filterRenderer={(onFilterChange) => {
                  return (
                    <Select
                      className="react-select primary"
                      options={ESTATUS_LIST}
                      value={ESTATUS_LIST.filter(function (option) {
                        return (
                          option.value ===
                          (where.Estatus
                            ? where.Estatus
                            : ESTATUS_LIST[0].value)
                        );
                      })}
                      name="Estatus"
                      onChange={(e) =>
                        onFilterChange({
                          target: { name: "Estatus", value: e.value },
                        })
                      }
                    ></Select>
                  );
                }}
              />
            </GridView>
          </>
        </Simplebar>,
        document.querySelector("#sidebarContainer")
      )}
    </>
  );
}
